import React from 'react';

const SEGMENTS = [
    { key: 'inbound_count', label: 'Inbound', className: 'bg-warning/10 text-warning' },
    { key: 'on_hand_count', label: 'On Hand', className: 'bg-primary/10 text-primary' },
    { key: 'outbound_count', label: 'Outbound', className: 'bg-info/10 text-info' },
    { key: 'return_count', label: 'Returns', className: 'bg-accent/10 text-accent' },
];

const StockStatusCell = ({ row }) => (
    <span className="inline-flex overflow-hidden rounded-full">
        {SEGMENTS.map(({ key, label, className }) => (
            <span
                key={key}
                title={label}
                className={`min-w-8 px-2 py-0.5 text-center text-[11px] font-semibold ${className}`}
            >
                {row.original[key] ?? 0}
            </span>
        ))}
    </span>
);

export default StockStatusCell;
